import React, { FC, ForwardedRef, forwardRef, useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';

import FormContext from '../../../components/form/FormContext';

export interface WithFormStateProps {
  disabled?: boolean;
  readOnly?: boolean;
  textOnly?: boolean;
  ref?: ForwardedRef<any>;
}

const withFormState = (WrappedComponent: FC<WithFormStateProps>) => {
  const WithFormState = forwardRef(({ disabled, readOnly, textOnly, ...props }: WithFormStateProps, ref) => {
    const {
      disabled: formDisabled,
      readOnly: formReadOnly,
      textOnly: formTextOnly,
    } = useContext(FormContext);

    return (
      <WrappedComponent
        disabled={formDisabled || disabled}
        readOnly={formReadOnly || readOnly}
        textOnly={formTextOnly || textOnly}
        ref={ref}
        {...props}
      />
    );
  });

  WithFormState.displayName = getWrappedDisplayName('WithFormState', WrappedComponent);

  return hoistNonReactStatics(WithFormState, WrappedComponent);
};

export default withFormState;
